// extracted by mini-css-extract-plugin
export var icon = "Contacts-module--icon--9bb31";
export var iconMail = "Contacts-module--iconMail--00935";
export var iconPhone = "Contacts-module--iconPhone--620a5";
export var iconWhatsApp = "Contacts-module--iconWhatsApp--74cda";
export var link = "Contacts-module--link--288e6";
export var withoutMargin = "Contacts-module--withoutMargin--84eee";
export var wrapper = "Contacts-module--wrapper--11d90";